import { RefreshIcon, SparkleIcon } from '@/components/icons/registry';
import { Icon } from '@/components/ui/icon';
import { Text } from '@/components/ui/text';
import { cn } from '@/utils/helpers/cn';

interface UpdateBannerProps {
  onUpdate: () => void;
  onDismiss: () => void;
  className?: string;
}

/**
 * Aviso de nova versão publicada.
 *
 * Posicionado no rodapé, e não no topo como no innova-admin: em telefone o
 * rodapé é a zona alcançável pelo polegar, e é onde docs/07-mobile-e-pwa.md §8
 * manda o banner ficar. `bottom-20` reserva o espaço da tab bar que virá.
 *
 * "Depois" é obrigatório (§8): o usuário pode estar no meio de um cadastro em
 * campo, e recarregar descartaria o formulário.
 */
export function UpdateBanner({ onUpdate, onDismiss, className }: UpdateBannerProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'fixed inset-x-4 bottom-20 z-50 flex items-center gap-3 rounded-xl border border-border',
        'bg-surface p-3 shadow-lg animate-in slide-in-from-bottom duration-300',
        className,
      )}
      style={{ marginBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <Icon as={SparkleIcon} size="sm" className="text-primary" />

      <Text variant="caption" className="flex-1">
        Nova versão disponível.
      </Text>

      {/* TODO: trocar por <Button> quando o primitivo existir em components/ui. */}
      <button
        type="button"
        onClick={onDismiss}
        className="min-h-11 shrink-0 rounded-lg px-3 text-sm text-muted-foreground active:bg-muted"
      >
        Depois
      </button>

      <button
        type="button"
        onClick={onUpdate}
        className={cn(
          'inline-flex min-h-11 shrink-0 items-center gap-1.5 rounded-lg px-3',
          'bg-primary text-sm font-medium text-primary-foreground active:bg-primary-hover',
        )}
      >
        <Icon as={RefreshIcon} size="sm" />
        Atualizar
      </button>
    </div>
  );
}
